import { render } from "./CardFour.vue?vue&type=template&id=527d76b6"
import script from "./CardFour.vue?vue&type=script&lang=js"
export * from "./CardFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__